
export function parseDDMMYYYYDate(dateStr) {
  const match = dateStr.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (!match) throw new Error(`Unexpected date format: ${dateStr}`);
  const [, day, month, year] = match;
  return new Date(`${year}-${month}-${day}`);
}
